(function () {
    const faq = () => {
        const tabBtns = document.querySelectorAll('.c-faq__tab');

        tabBtns.forEach((btn, index) => {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                tabBtns.forEach(otherBtn => {
                    otherBtn.classList.remove('c-faq__tab--active');
                    otherBtn.removeAttribute('aria-current');
                });
                tabBtns[index].classList.add('c-faq__tab--active');
                tabBtns[index].setAttribute('aria-current', 'location');

                const targetTab = document.getElementById(btn.getAttribute('data-tab'));
                if (targetTab) {
                    targetTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    window.history.replaceState(null, '', `#${targetTab.id}`);
                }
            });
        });
        
    }

document.addEventListener('shopify:section:load', faq);
faq();

})();
